export { default } from "./heading";
